export * from "./menu-links.component";
